import { DefaultObservationImage } from 'pages/pointClouds/components/DefaultObservationImage'
import { ObservationCarousel } from 'pages/pointClouds/components/shared/ObservationCarousel'
import { useObservationImages } from 'pages/pointClouds/utils'
import React from 'react'
import styled from 'styled-components'
import { GeckoSiteObservation } from 'types'

const MainContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`

const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  min-height: 48px;
`

const ImageSection = styled.div`
  flex-shrink: 0;
  width: 120px;
`

const ObservationName = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: white;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ObservationDescription = styled.div`
  font-size: 12px;
  color: #ccc;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

interface ObservationContentAreaProps {
  observation: GeckoSiteObservation
}

export const ObservationContentArea: React.FC<ObservationContentAreaProps> = ({
  observation,
}) => {
  const images = useObservationImages(observation?.id)

  return (
    <MainContent>
      <TextContent>
        <ObservationName>
          {observation.data?.name || 'Observation'}
        </ObservationName>
        <ObservationDescription>
          {observation.data?.description || 'No description'}
        </ObservationDescription>
      </TextContent>
      <ImageSection>
        <ObservationCarousel
          images={images}
          carouselProps={{
            autoplay: images.length > 1,
            autoplaySpeed: 2000,
            dots: images.length > 1,
          }}
          defaultImageComponent={
            <DefaultObservationImage
              observation={observation}
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#222',
              }}
            />
          }
          style={{
            width: '120px',
            height: '80px',
            flexShrink: 0,
            borderRadius: '4px',
            overflow: 'hidden',
            pointerEvents: 'auto',
          }}
          imageStyle={{
            objectFit: 'cover',
            aspectRatio: '1',
          }}
        />
      </ImageSection>
    </MainContent>
  )
}
